import { NgModule } from '@angular/core';

import { LinkedItemsStateModule } from '@ninety/web/pages/detail-view/_shared/linked-items/linked-items-ngrx.module';
import { DetailViewStateModule } from '@ninety/web/pages/detail-view/_state/detail-view-state.module';
import { GettingStartedStateModule } from '@ninety/web/pages/getting-started/_state/getting-started-state.module';
import { HeadlinesStateModule } from '@ninety/web/pages/headlines/_state/headlines-state.module';
import { InboxNgrxModule } from '@ninety/web/pages/inbox/inbox-ngrx.module';
import { IssuesV2StateModule } from '@ninety/web/pages/issues-v2/_state/issues-v2-state.module';
import { LayoutStateModule } from '@ninety/web/pages/layouts/_state/layout-state.module';
import { GridLayoutModule } from '@ninety/web/pages/layouts/grid-layout/grid-layout.module';
import { MazModule } from '@ninety/web/pages/maz/maz.module';
import { MeetingsStateModule } from '@ninety/web/pages/meeting/_state/meetings-state.module';
import { NotificationFeedModule } from '@ninety/web/pages/notification-feed/notification-feed.module';
import { RockStateModule } from '@ninety/web/pages/rocks/_state/rocks-state.module';
import { TodoStateModule } from '@ninety/web/pages/todos/_state/todo-ngrx.module';

@NgModule({
  imports: [
    GettingStartedStateModule,
    MazModule,
    DetailViewStateModule,
    LayoutStateModule,
    TodoStateModule,
    LinkedItemsStateModule,
    MeetingsStateModule,
    RockStateModule,
    HeadlinesStateModule,
    IssuesV2StateModule,
    InboxNgrxModule,
    NotificationFeedModule,
    GridLayoutModule,
  ],
})
export class AppFeatureStateModule {}
